var _mask, _path, _mask2, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresent(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "present_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.742 12a1 1 0 011-1H23a1 1 0 011 1v11.32a1 1 0 01-1 1H2.742a1 1 0 01-1-1V12z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.742 12a1 1 0 011-1H23a1 1 0 011 1v11.32a1 1 0 01-1 1H2.742a1 1 0 01-1-1V12z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#present_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "present_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12a1 1 0 001 1h24a1 1 0 001-1V7a1 1 0 00-1-1H1a1 1 0 00-1 1v5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12a1 1 0 001 1h24a1 1 0 001-1V7a1 1 0 00-1-1H1a1 1 0 00-1 1v5z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#present_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 001 1h8.526a1 1 0 001-1V4.69a1 1 0 00-.644-.935L8.42 2.06C5.803 1.065 3 2.999 3 5.8V6z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6h8.526V4.69l-4.46-1.695C6.102 2.249 4 3.699 4 5.799V6z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6a1 1 0 01-1 1h-8.526a1 1 0 01-1-1V4.69a1 1 0 01.644-.935L17.58 2.06C20.197 1.065 23 2.999 23 5.8V6z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6h-8.526V4.69l4.46-1.695C19.898 2.249 22 3.699 22 5.799V6z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 6h4v18h-4z"
  })));
}
export default SvgPresent;